export const initialState = () => {

    return {
        isAuth: false,
        resetPassword: false,   //true
        user: null,             //true null {userId:6,phoneNumber:'+7926*****12}
        authNumber: null,       //false
        personalData:{},                    // these fields are required for workerProfile
        requests: {
            // these fields are required for request
            userRequests: [],
            requestAttachments: [],
        },
        localTrips: {
            localTripsList: null,
            localTripDetail: null,
            createdLocalTrip: null,
            localTripReasons: null,
            localTripDecisions: null,
            cancelledLocalTrip: null,
            approvedLocalTrip: null,
            localTripError: null,
        },
        // leaves: [],
        employees: {
            cross: {
                period: null,
                data: [],
            },
            requests: [],
        },
        documents:{},
        myDivision: {
            employeeList: [],
        },
    };


};
